// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/user_directory_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Member } from "./user_directory_model_pb";
import { file_bffuser_v1_user_directory_model } from "./user_directory_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/user_directory_service.proto.
 */
export const file_bffuser_v1_user_directory_service: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ1c2VyL3YxL3VzZXJfZGlyZWN0b3J5X3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiFAoSTGlzdE1lbWJlcnNSZXF1ZXN0IjoKE0xpc3RNZW1iZXJzUmVzcG9uc2USIwoHbWVtYmVycxgBIAMoCzISLmJmZnVzZXIudjEuTWVtYmVyMmgKFFVzZXJEaXJlY3RvcnlTZXJ2aWNlElAKC0xpc3RNZW1iZXJzEh4uYmZmdXNlci52MS5MaXN0TWVtYmVyc1JlcXVlc3QaHy5iZmZ1c2VyLnYxLkxpc3RNZW1iZXJzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bffuser_v1_user_directory_model]);

/**
 * @generated from message bffuser.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"bffuser.v1.ListMembersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_user_directory_service, 0);

/**
 * @generated from message bffuser.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"bffuser.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.Member members = 1;
   */
  members: Member[];
};

/**
 * Describes the message bffuser.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_user_directory_service, 1);

/**
 * UserDirectoryService は読み取り専用 BFF 集約サービス。
 * backend internalapi.v1.UserDirectoryService.ListMembers に fan-out する。
 *
 * @generated from service bffuser.v1.UserDirectoryService
 */
export const UserDirectoryService: GenService<{
  /**
   * ListMembers returns all members of the caller's organisation.
   *
   * @generated from rpc bffuser.v1.UserDirectoryService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_user_directory_service, 0);

